var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "auth-sidebar-registration" }, [
    _c("section", { staticClass: "register component" }, [
      _c(
        "div",
        { staticClass: "register-form-wrapper" },
        [
          _c("div", { staticClass: "register-form-logo icon-fan-logo-black" }, [
            _c("span", { staticClass: "sr-only" }, [
              _vm._v(_vm._s(_vm.tc("auth.fansMoTitle"))),
            ]),
          ]),
          _vm._v(" "),
          _c("registration-form", {
            attrs: { source: "MoWeb:BookingEngine:TeaserSignup" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var serverErrorMsg = ref.serverErrorMsg
                  var isValid = ref.isValid
                  var isLoading = ref.isLoading
                  var grecaptchaReadyCallback = ref.grecaptchaReadyCallback
                  var grecaptchaReady = ref.grecaptchaReady
                  var grecaptchaCallback = ref.grecaptchaCallback
                  var grecaptchaExecute = ref.grecaptchaExecute
                  var grecaptchaToken = ref.grecaptchaToken
                  return _c(
                    "form",
                    {
                      staticClass: "form register-form",
                      attrs: {
                        id: "register-form",
                        action: "/api/v1/profile/register",
                      },
                    },
                    [
                      _c("fieldset", [
                        _c("legend", [
                          _vm._v(_vm._s(_vm.registrationComponentData.Title)),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flex-grid-1-col gutter-lg" },
                          [
                            _c(
                              "div",
                              { staticClass: "input dropdown user-titles" },
                              [
                                _c(
                                  "select",
                                  {
                                    staticClass: "req",
                                    attrs: {
                                      id: "usertitle",
                                      name: "title",
                                      "data-val": "true",
                                      "data-val-required":
                                        _vm.getValidationForField(
                                          "required",
                                          "title"
                                        ),
                                      "data-field-type": "DropdownList",
                                    },
                                  },
                                  [
                                    _c("option", { attrs: { value: "" } }),
                                    _vm._v(" "),
                                    _vm._l(_vm.userTitles, function (title) {
                                      return _c(
                                        "option",
                                        {
                                          key: title.value,
                                          domProps: { value: title.value },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(title.label) +
                                              "\n                  "
                                          ),
                                        ]
                                      )
                                    }),
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "floating req",
                                    attrs: { for: "title" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.tc("formFields.title")) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "field-validation-valid",
                                  attrs: {
                                    "data-valmsg-for": "title",
                                    "data-valmsg-replace": "true",
                                  },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "input" }, [
                              _c("input", {
                                staticClass: "req",
                                attrs: {
                                  id: "firstname",
                                  type: "text",
                                  name: "firstname",
                                  maxlength: "255",
                                  value: "",
                                  "data-val": "true",
                                  "data-rule-minlength": "1",
                                  "data-rule-maxlength": "50",
                                  "data-msg-minlength":
                                    _vm.getValidationForField("minChars", "1"),
                                  "data-msg-maxlength":
                                    _vm.getValidationForField("maxChars", "50"),
                                  "data-val-required":
                                    _vm.getValidationForField(
                                      "required",
                                      "firstName"
                                    ),
                                  "data-val-no-special-chars": _vm.tc(
                                    "validations.noSpecialChars"
                                  ),
                                  "data-field-type": "SingleLineText",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "req floating",
                                  attrs: { for: "firstname" },
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.tc("formFields.firstName")) +
                                      "\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "field-validation-valid",
                                attrs: {
                                  "data-valmsg-for": "firstname",
                                  "data-valmsg-replace": "true",
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "input" }, [
                              _c("input", {
                                staticClass: "req",
                                attrs: {
                                  id: "lastname",
                                  type: "text",
                                  name: "lastname",
                                  maxlength: "255",
                                  value: "",
                                  "data-val": "true",
                                  "data-rule-minlength": "1",
                                  "data-rule-maxlength": "65",
                                  "data-msg-minlength":
                                    _vm.getValidationForField("minChars", "1"),
                                  "data-msg-maxlength":
                                    _vm.getValidationForField("maxChars", "65"),
                                  "data-val-required":
                                    _vm.getValidationForField(
                                      "required",
                                      "lastName"
                                    ),
                                  "data-val-no-special-chars": _vm.tc(
                                    "validations.noSpecialChars"
                                  ),
                                  "data-field-type": "SingleLineText",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "req floating",
                                  attrs: { for: "lastname" },
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.tc("formFields.lastName")) +
                                      "\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "field-validation-valid",
                                attrs: {
                                  "data-valmsg-for": "lastname",
                                  "data-valmsg-replace": "true",
                                },
                              }),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flex-grid-1-col gutter-lg" },
                          [
                            _c("div", { staticClass: "input" }, [
                              _c("input", {
                                staticClass: "req",
                                attrs: {
                                  id: "email",
                                  type: "email",
                                  name: "email",
                                  value: "",
                                  "data-val": "true",
                                  maxlength: "255",
                                  "data-val-external": "email",
                                  "data-rule-minlength": "6",
                                  "data-rule-maxlength": "255",
                                  "data-msg-minlength":
                                    _vm.getValidationForField("minChars", "6"),
                                  "data-msg-maxlength":
                                    _vm.getValidationForField(
                                      "maxChars",
                                      "255"
                                    ),
                                  "data-external-msg":
                                    _vm.getValidationForField("externalEmail"),
                                  "data-val-required":
                                    _vm.getValidationForField(
                                      "required",
                                      "email"
                                    ),
                                  "data-val-regex": _vm.tc("validations.email"),
                                  "data-val-regex-pattern":
                                    "^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,17}$",
                                  "data-field-type": "Email",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "req floating",
                                  attrs: { for: "email" },
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.tc("formFields.email")) +
                                      "\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "field-validation-valid",
                                attrs: {
                                  "data-valmsg-for": "email",
                                  "data-valmsg-replace": "true",
                                },
                              }),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flex-grid-1-col gutter-lg" },
                          [
                            _c("div", { staticClass: "input" }, [
                              _c("input", {
                                staticClass: "req",
                                attrs: {
                                  id: "email_confirmation",
                                  type: "email",
                                  name: "email_confirmation",
                                  value: "",
                                  maxlength: "255",
                                  "data-val": "true",
                                  "data-val-external": "email",
                                  "data-rule-minlength": "6",
                                  "data-rule-maxlength": "255",
                                  "data-msg-minlength":
                                    _vm.getValidationForField("minChars", "6"),
                                  "data-msg-maxlength":
                                    _vm.getValidationForField(
                                      "maxChars",
                                      "255"
                                    ),
                                  "data-external-msg":
                                    _vm.getValidationForField("externalEmail"),
                                  "data-val-required":
                                    _vm.getValidationForField(
                                      "required",
                                      "emailConfirmation"
                                    ),
                                  "data-val-equals-to": "#email",
                                  "data-val-equals": _vm.getValidationForField(
                                    "confirmationField",
                                    "emailConfirmation"
                                  ),
                                  "data-val-regex": _vm.tc("validations.email"),
                                  "data-val-regex-pattern":
                                    "^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,17}$",
                                  "data-field-type": "Email",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "req floating",
                                  attrs: { for: "email_confirmation" },
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.tc("formFields.emailConfirmation")
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "field-validation-valid",
                                attrs: {
                                  "data-valmsg-for": "email_confirmation",
                                  "data-valmsg-replace": "true",
                                },
                              }),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flex-grid-2-col gutter-lg" },
                          [
                            _c(
                              "div",
                              { staticClass: "input dropdown country-code" },
                              [
                                _c(
                                  "select",
                                  {
                                    staticClass: "req",
                                    attrs: {
                                      id: "phoneCountryCode",
                                      name: "phoneCountryCode",
                                      value: "",
                                      "data-val": "true",
                                      "data-val-external": "phone",
                                      "data-external-msg":
                                        _vm.getValidationForField(
                                          "externalPhone"
                                        ),
                                      "data-val-required":
                                        _vm.getValidationForField(
                                          "required",
                                          "country"
                                        ),
                                      "data-field-type": "DropdownList",
                                    },
                                  },
                                  [
                                    _c("option", { attrs: { value: "" } }),
                                    _vm._v(" "),
                                    _vm._l(_vm.countries, function (country) {
                                      return _c(
                                        "option",
                                        {
                                          key: country.Name + "Phone",
                                          domProps: {
                                            value: country.CallingCode,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                country.Name +
                                                  " (+" +
                                                  country.CallingCode +
                                                  ")"
                                              ) +
                                              "\n                  "
                                          ),
                                        ]
                                      )
                                    }),
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "req floating",
                                    attrs: { for: "phoneCountryCode" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.tc("formFields.country")) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "field-validation-valid",
                                  attrs: {
                                    "data-valmsg-for": "phoneCountryCode",
                                    "data-valmsg-replace": "true",
                                  },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "input phone" }, [
                              _c("input", {
                                staticClass: "req",
                                attrs: {
                                  id: "phoneNumber",
                                  type: "tel",
                                  name: "phoneNumber",
                                  value: "",
                                  "data-val": "true",
                                  "data-val-external": "phone",
                                  "data-external-msg":
                                    _vm.getValidationForField("externalPhone"),
                                  "data-val-required":
                                    _vm.getValidationForField(
                                      "required",
                                      "phoneNumber"
                                    ),
                                  "data-val-regex-pattern":
                                    "^[\\d\\+\\-\\(\\)\\s]*$",
                                  "data-val-regex": _vm.tc("validations.phone"),
                                  "data-rule-minlength": "5",
                                  "data-rule-maxlength": "17",
                                  "data-msg-minlength":
                                    _vm.getValidationForField("minChars", "5"),
                                  "data-msg-maxlength":
                                    _vm.getValidationForField("maxChars", "17"),
                                  "data-val-phone-number":
                                    _vm.tc("validations.phone"),
                                  "data-field-type": "NativePhone",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "req floating",
                                  attrs: { for: "phoneNumber" },
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.tc("formFields.phoneNumber")) +
                                      "\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "field-validation-valid",
                                attrs: {
                                  "data-valmsg-for": "phoneNumber",
                                  "data-valmsg-replace": "true",
                                },
                              }),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flex-grid-1-col gutter-lg" },
                          [
                            _c("div", { staticClass: "input" }, [
                              _c("input", {
                                staticClass: "req",
                                attrs: {
                                  id: "password",
                                  type: "password",
                                  name: "password",
                                  value: "",
                                  "data-val": "true",
                                  "data-val-required":
                                    _vm.getValidationForField(
                                      "required",
                                      "password"
                                    ),
                                  "data-rule-minlength": "8",
                                  "data-msg-minlength":
                                    _vm.getValidationForField(
                                      "passwordLength",
                                      "8"
                                    ),
                                  "data-val-hasnumber": _vm.tc(
                                    "validations.passwordNumber"
                                  ),
                                  "data-val-haslowercase": _vm.tc(
                                    "validations.passwordLowerCase"
                                  ),
                                  "data-val-hasuppercase": _vm.tc(
                                    "validations.passwordUpperCase"
                                  ),
                                  "data-val-special-chars": _vm.tc(
                                    "validations.specialChars"
                                  ),
                                  "data-val-has-no-password-as-input": _vm.tc(
                                    "validations.hasNoPasswordAsInput"
                                  ),
                                  "data-val-consecutive-characters": _vm.tc(
                                    "validations.consecutiveCharacters"
                                  ),
                                  "data-password-validation": "true",
                                  "data-field-type": "PasswordField",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "req floating",
                                  attrs: { for: "password" },
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.tc("formFields.password")) +
                                      "\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("em", {
                                staticClass: "fa fa-eye password-toggle",
                                attrs: {
                                  "aria-label": _vm.tc(
                                    "formFields.passwordVisiblityToggle"
                                  ),
                                  tabindex: "0",
                                  type: "button",
                                  role: "switch",
                                  "aria-checked": "false",
                                  "data-for": "password",
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "password-rules" }, [
                                _c("small", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.tc("formFields.passwordRules")
                                    ),
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "field-validation-valid",
                                attrs: {
                                  "data-valmsg-for": "password",
                                  "data-valmsg-replace": "true",
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "input" }, [
                              _c("input", {
                                staticClass: "req",
                                attrs: {
                                  id: "password_confirmation",
                                  type: "password",
                                  name: "password_confirmation",
                                  value: "",
                                  "data-val": "true",
                                  "data-val-equals-to": "#password",
                                  "data-val-required":
                                    _vm.getValidationForField(
                                      "required",
                                      "passwordConfirmation"
                                    ),
                                  "data-val-equals": _vm.getValidationForField(
                                    "confirmationField",
                                    "passwordConfirmation"
                                  ),
                                  "data-field-type": "PasswordField",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "req floating",
                                  attrs: { for: "password_confirmation" },
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.tc(
                                          "formFields.passwordConfirmation"
                                        )
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("em", {
                                staticClass: "fa fa-eye password-toggle",
                                attrs: {
                                  "aria-label": _vm.tc(
                                    "formFields.passwordVisiblityToggle"
                                  ),
                                  tabindex: "0",
                                  type: "button",
                                  role: "switch",
                                  "aria-checked": "false",
                                  "data-for": "password_confirmation",
                                },
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "field-validation-valid",
                                attrs: {
                                  "data-valmsg-for": "password_confirmation",
                                  "data-valmsg-replace": "true",
                                },
                              }),
                            ]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("fieldset", [
                        _c("legend", { staticClass: "sr-only" }, [
                          _vm._v("\n              Agreements\n            "),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flex-grid-1-col gutter-lg" },
                          [
                            _c("div", { staticClass: "text-block no-label" }, [
                              _c("h3", { staticClass: "agreements-title" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.registrationComponentData
                                        .StayConnectedTitle
                                    ) +
                                    "\n                "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "agreements-description",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.registrationComponentData
                                      .StayConnectedDescription
                                  ),
                                },
                              }),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flex-grid-1-col gutter-lg" },
                          [
                            _c(
                              "ul",
                              {},
                              [
                                _vm.lang.toLowerCase() === "zh-cn"
                                  ? [
                                      _c("li", [
                                        _c("label", [
                                          _c("input", {
                                            attrs: {
                                              id: "policy_use",
                                              "data-val": "true",
                                              "data-val-isChecked": _vm.tc(
                                                "validations.ischecked"
                                              ),
                                              name: "policy_use",
                                              type: "checkbox",
                                            },
                                          }),
                                          _vm._v(
                                            "\n                      MOHG 将根据其隐私政策处理您的个人数据。您同意该类使用。*\n                    "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "field-validation-valid",
                                          attrs: {
                                            "data-valmsg-for": "policy_use",
                                            "data-valmsg-replace": "true",
                                          },
                                        }),
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _c("label", [
                                          _c("input", {
                                            attrs: {
                                              id: "policy_share",
                                              "data-val": "true",
                                              "data-val-isChecked": _vm.tc(
                                                "validations.ischecked"
                                              ),
                                              name: "policy_share",
                                              type: "checkbox",
                                            },
                                          }),
                                          _vm._v(
                                            "\n                      MOHG\n                      将根据其隐私政策将您的个人数据传输至第三方。您同意该类共享。*\n                    "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "field-validation-valid",
                                          attrs: {
                                            "data-valmsg-for": "policy_share",
                                            "data-valmsg-replace": "true",
                                          },
                                        }),
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _c("label", [
                                          _c("input", {
                                            attrs: {
                                              id: "policy_outside",
                                              "data-val": "true",
                                              "data-val-isChecked": _vm.tc(
                                                "validations.ischecked"
                                              ),
                                              name: "policy_outside",
                                              type: "checkbox",
                                            },
                                          }),
                                          _vm._v(
                                            "\n                      MOHG\n                      将根据其隐私政策将您的个人数据传输至中华人民共和国境外的第三方。您同意此类共享。*\n                    "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "field-validation-valid",
                                          attrs: {
                                            "data-valmsg-for": "policy_outside",
                                            "data-valmsg-replace": "true",
                                          },
                                        }),
                                      ]),
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("li", [
                                  _c("label", [
                                    _c("input", {
                                      attrs: {
                                        id: "communications_agree",
                                        name: "communications_agree",
                                        type: "checkbox",
                                      },
                                      domProps: {
                                        checked:
                                          _vm.defaultCheckedForRegistration,
                                      },
                                    }),
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.registrationComponentData
                                            .AgreeCommunications
                                        ) +
                                        "\n                  "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass: "field-validation-valid",
                                    attrs: {
                                      "data-valmsg-for": "communications_agree",
                                      "data-valmsg-replace": "true",
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _c("label", [
                                    _c("input", {
                                      attrs: {
                                        id: "sensitive_data_agree",
                                        name: "sensitive_data_agree",
                                        type: "checkbox",
                                      },
                                      domProps: {
                                        checked:
                                          _vm.defaultCheckedForRegistration,
                                      },
                                    }),
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.registrationComponentData
                                            .AgreeSensitiveData
                                        ) +
                                        "\n                  "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass: "field-validation-valid",
                                    attrs: {
                                      "data-valmsg-for": "sensitive_data_agree",
                                      "data-valmsg-replace": "true",
                                    },
                                  }),
                                ]),
                              ],
                              2
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flex-grid-1-col gutter-lg" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "agreements-wrapper text-block no-label",
                              },
                              [
                                _c("h3", { staticClass: "agreements-title" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.registrationComponentData.TermsTitle
                                      ) +
                                      "\n                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "collapsible component" },
                                  [
                                    _c(
                                      "ul",
                                      {
                                        staticClass:
                                          "collapsible-wrapper container",
                                        attrs: {
                                          "aria-label":
                                            "Collapsible Control Group Buttons",
                                        },
                                      },
                                      [
                                        _c("accordion-tab", {
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var toggleTab = ref.toggleTab
                                                  var expanded = ref.expanded
                                                  return [
                                                    _c(
                                                      "li",
                                                      {
                                                        staticClass:
                                                          "collapsible-item",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "collapsible-item-content",
                                                            class: expanded
                                                              ? "expanded"
                                                              : "",
                                                            attrs: {
                                                              id: "agreements-collapsible",
                                                              "aria-hidden":
                                                                expanded
                                                                  ? "false"
                                                                  : "true",
                                                            },
                                                          },
                                                          [
                                                            _c("div", {
                                                              staticClass:
                                                                "collapsible-item-content-wrapper",
                                                              attrs: {
                                                                tabindex: "0",
                                                              },
                                                              domProps: {
                                                                innerHTML:
                                                                  _vm._s(
                                                                    _vm
                                                                      .registrationComponentData
                                                                      .Terms
                                                                  ),
                                                              },
                                                              on: {
                                                                focus:
                                                                  toggleTab,
                                                              },
                                                            }),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("button", {
                                                          staticClass:
                                                            "collapsible-item-label",
                                                          class: expanded
                                                            ? "expanded"
                                                            : "",
                                                          attrs: {
                                                            id: "agreements-collapsible-control",
                                                            "aria-controls":
                                                              "content-1",
                                                            "aria-expanded":
                                                              expanded
                                                                ? "true"
                                                                : "false",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.preventDefault()
                                                              return toggleTab(
                                                                $event
                                                              )
                                                            },
                                                            enter: toggleTab,
                                                            keydown: function (
                                                              $event
                                                            ) {
                                                              if (
                                                                !$event.type.indexOf(
                                                                  "key"
                                                                ) &&
                                                                _vm._k(
                                                                  $event.keyCode,
                                                                  "space",
                                                                  32,
                                                                  $event.key,
                                                                  [
                                                                    " ",
                                                                    "Spacebar",
                                                                  ]
                                                                )
                                                              ) {
                                                                return null
                                                              }
                                                              $event.preventDefault()
                                                              return toggleTab(
                                                                $event
                                                              )
                                                            },
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.registrationComponentData.ReCaptchaEnabled
                        ? [
                            _c("grecaptcha", {
                              ref: "grecaptchaLogin",
                              attrs: {
                                sitekey:
                                  _vm.registrationComponentData
                                    .ReCaptchaSiteKey,
                                "element-id": "g-recaptcha",
                              },
                              on: {
                                "grecaptcha-callback": grecaptchaCallback,
                                "grecaptcha-ready": grecaptchaReadyCallback,
                              },
                            }),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: grecaptchaToken,
                                  expression: "grecaptchaToken",
                                },
                              ],
                              attrs: {
                                type: "hidden",
                                name: "grecaptchaToken",
                              },
                              domProps: { value: grecaptchaToken },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  grecaptchaToken = $event.target.value
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("input", {
                              attrs: {
                                type: "hidden",
                                name: "reCaptchaEnabled",
                              },
                              domProps: {
                                value:
                                  _vm.registrationComponentData
                                    .ReCaptchaEnabled,
                              },
                            }),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-submit" }, [
                        _vm.registrationComponentData.ReCaptchaEnabled
                          ? _c(
                              "button",
                              {
                                staticClass: "button register-cta",
                                class: [{ loading: isLoading }],
                                attrs: {
                                  disabled: !isValid || !grecaptchaReady,
                                },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return grecaptchaExecute($event)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.tc("auth.signUpCta")) +
                                    "\n            "
                                ),
                              ]
                            )
                          : _c(
                              "button",
                              {
                                staticClass: "button register-cta",
                                class: [{ loading: isLoading }],
                                attrs: { disabled: !isValid },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.tc("auth.signUpCta")) +
                                    "\n            "
                                ),
                              ]
                            ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "sr-only", attrs: { role: "status" } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  isLoading
                                    ? _vm.tc(
                                        "accessibility.loadingButtonStatus"
                                      )
                                    : ""
                                ) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "error-msg",
                        class: [{ show: !!serverErrorMsg }],
                        domProps: { innerHTML: _vm._s(serverErrorMsg) },
                      }),
                    ],
                    2
                  )
                },
              },
            ]),
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }